var DepthOfFieldFilter3D = (function () {
    function DepthOfFieldFilter3D() {
    }
    return DepthOfFieldFilter3D;
}());
export { DepthOfFieldFilter3D };
